import { ServerVars } from 'server-vars';
import { AB_TEST_TYPES, SEO_TEST_SLOT } from 'dibs-constants/exports/abTestConstants';
import type { AbTestConfigMapType, AbTestConfigType } from './types/abTesting';

/**
 * Return the A/B configuration
 */
export const getConfig = (serverVars: ServerVars): AbTestConfigMapType => {
    const isMobile = serverVars.get('settings.isMobile');
    const abTestConfig: AbTestConfigMapType = serverVars.get('abTestConfig') || {};
    const filteredConfigs = Object.keys(abTestConfig).reduce(
        (acc: AbTestConfigMapType, configName: string) => {
            let activeConfig;
            const config = abTestConfig[configName] || [];
            const standardOrSeoConfig = config.filter(
                (configItem: AbTestConfigType) =>
                    configItem.testType === AB_TEST_TYPES.STANDARD ||
                    configItem.testGroup === SEO_TEST_SLOT
            );
            if (standardOrSeoConfig.length) {
                activeConfig = standardOrSeoConfig;
            } else {
                const testType = isMobile ? AB_TEST_TYPES.MOBILE : AB_TEST_TYPES.RESPONSIVE;
                activeConfig = config.filter(
                    (configItem: AbTestConfigType) => configItem.testType === testType
                );
            }
            if (!acc[configName] && activeConfig) {
                acc = { ...acc, [configName]: activeConfig };
            }
            return acc;
        },
        {}
    );

    return filteredConfigs;
};
